export default "__VITE_ASSET__BIQCUpRc__"